var map = {
	"./ActionsModal/Cambio.vue": 812,
	"./ActionsModal/SaveChanges.vue": 813,
	"./ActionsModal/index.vue": 248,
	"./agrocolor.vue": 2086,
	"./araporcei.vue": 2087,
	"./coplaca/ParcelasActionsMultiple.vue": 1143,
	"./coplaca/index.vue": 2088,
	"./default.vue": 2089,
	"./demo.vue": 2090,
	"./sites.vue": 309,
	"./widgets/auditorias.vue": 814,
	"./widgets/dictamenes.vue": 817,
	"./widgets/pacs.vue": 819,
	"./widgets/revisiones.vue": 816,
	"./widgets/solicitudes.vue": 815,
	"./widgets/toma_muestras.vue": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1795;